import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';

export default function LocationDetailedInfo() {
  const rootElement = ReactDOM.createRoot(document.getElementById('root_element_location_page'));

  rootElement.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
